import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
//
import { LoadingComponent } from './loading/loading.component';
import { AuthorizePPComponent } from './authorizePP/authorizePP.component';
import { AuthGuard } from './app.guard';
import { UserService } from './user/user.service';
import { UserProfile } from './user/user.profile';
import { AuthorizePPService } from './authorizePP/authorizePP.service';

@NgModule({
  declarations: [
    LoadingComponent,
    AuthorizePPComponent
  ],
  imports: [
    CommonModule,
    BrowserModule
  ],
  exports:[ CommonModule,BrowserModule,FormsModule,LoadingComponent,AuthorizePPComponent ],
  providers: [
    AuthGuard,
    UserService,
    UserProfile,
    AuthorizePPService
  ],
})
export class ShareModule { }



// WEBPACK FOOTER //
// ./src/app/share.module.ts